export const baseUrl = process.env.REACT_APP_API_URL;

export const LoginApi = 'login';
export const CustomerLoginApi = 'customers/login';
export const CustomerSignupApi = 'customers/signUp';
export const VerifySingupNo = 'customers/verifySignUpNo';
export const VerifySingupOTP = 'customers/VerifySignUpotp';
export const OtpVerifyApi = 'customers/otp';
export const ResetPasswordApi = 'resetPassword';
export const UserLogoutApi = 'logout';
export const RefreshTokenApi = 'refreshToken';
export const getUserProfile = 'getUserProfile';
